import React, { Fragment } from 'react';
import { useQueryClient, useMutation, useQuery } from 'react-query';
import { injectIntl } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';

import Language from './language';
import Breadcrumb from './breadcrumb';
import { Notify } from 'components';
import { BackIcon, MenuIcon } from 'icons';

import messages from 'messages';

/* eslint no-restricted-globals:0 */

function Header({ ...props }) {
    const { formatMessage } = props.intl;

    const queryClient = useQueryClient();

    const { domain, name } = queryClient.getQueryData('restaurant') || '';
    const notify = useQuery('notify')?.data || {};
    const bag = useQuery('bag')?.data || {};

    const restaurantMutation = useMutation('restaurant-mutation');

    const history = useHistory();

    const checkLocation = () => {
        return (
            window.location.pathname === `/${domain}/thankyou` ||
            window.location.pathname === `/${domain}` ||
            window.location.pathname === `/${domain}/`
        );
    };

    const toggleBag = () => {
        queryClient.setQueryData('app', (prevData) => ({
            ...prevData,
            toggleBag: !prevData.toggleBag,
        }));
    };

    const toggleLanguage = () => {
        queryClient.setQueryData('app', (prevData) => ({
            ...prevData,
            toggleLanguage: !prevData.toggleLanguage,
        }));
    };

    if (checkLocation() || restaurantMutation.isLoading) return '';

    return (
        <Fragment>
            <header>
                <div
                    data-test="back-button"
                    className="navigation"
                    onClick={() => history.goBack()}
                >
                    <BackIcon size={16} />
                </div>

                <h1 data-test="name-restaurant">
                    <Link to={`/${domain}`}>{name}</Link>
                </h1>

                <div className="right-side">
                    <Language />

                    <div data-test="bag-button" className="bag">
                        <button onClick={() => toggleBag()}>
                            {formatMessage(messages.genericBag)} ({bag.length})
                        </button>
                        <MenuIcon size={15} className="icon" onClick={() => toggleLanguage()} />
                    </div>
                </div>
            </header>
            <Notify type={notify.type} text={notify.text} action={notify.action} />
            <Breadcrumb />
            <Language />
        </Fragment>
    );
}

export default injectIntl(Header);
